module.exports = __webpack_public_path__ + "static/media/settings.e33d2a8d.svg";